<template>
  <div class="user-set main-panel large">
    <h1 class="panel-title">用户版本</h1>
    <div class="top">
      <div class="form">
        <div class="row">
          <div class="item col-1">
            <div class="label" require>用户名</div>
            <label
              ><input type="text" class="cg-input" v-model="form.username"
            /></label>
          </div>
          <div class="item col-1">
            <div class="label" require>版本</div>
            <el-select
              v-model="form.bb"
              placeholder="请选择版本"
              style="width: 100%"
              clearable
            >
              <el-option
                v-for="item in banben"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <el-button class="publish-btn" size="small" @click="saves"
              >查询</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <el-table
      :data="users"
      height="500px"
      border
      style="width: 100%"
      class="custom-table"
    >
      <el-table-column align="center" prop="nickName" label="用户名">
        <template #default="scope">
          {{
            scope.row.nickName == "" ? scope.row.bindCode : scope.row.nickName
          }}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="bindCode" label="星球码" />
      <el-table-column align="center" prop="versionName" label="版本" />
      <el-table-column align="center" label="操作">
        <template #default="scope">
          <div class="options">
            <i
              class="update-icon el-icon-edit"
              title="修改"
              @click="up(scope.row)"
            ></i>
            <el-popconfirm
              title="确认删除吗?"
              confirmButtonText="确认"
              cancelButtonText="取消"
              @confirm="delUser(scope.row.id)"
            >
              <template #reference>
                <i class="del-icon el-icon-close" title="删除"></i>
              </template>
            </el-popconfirm>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="修改" center width="366px" v-model="dialogTableVisible">
      <div class="update-view">
        <div class="item">
          <span class="label">用户id</span>
          <label
            ><input
              type="text"
              class="cg-input"
              v-model="upid"
              :disabled="true"
          /></label>
        </div>
        <div class="item">
          <span class="label" require>版本</span>
          <el-select
            size="mini"
            class="cg-input"
            filterable
            v-model="upbb"
            placeholder="请选择版本"
            style="padding: 4px 0"
          >
            <el-option
              v-for="item in banben"
              :key="item.id"
              :label="item.name"
              :value="+item.id"
            />
          </el-select>
        </div>
        <div class="footer">
          <el-button class="publish-btn" size="small" @click="save"
            >保存</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
/* eslint-disable no-undef */
import { ref, reactive, onMounted, getCurrentInstance, watch } from "vue";
const { proxy } = getCurrentInstance();

//弹窗字段
const upbb = ref("");
const upid = ref("");

const form = reactive({
  username: "", // 用户名
  bb: "", //版本
});
const dialogTableVisible = ref(false); //弹窗控制
const users = ref([]); // 版本用户列表
const banben = ref([
  { id: 0, name: "注册版" },
  { id: 1, name: "商家1号版" },
  { id: 2, name: "商家2号版" },
]);

// 缓存值
const STORAGE_KEY = "member-version";

// 监听查询条件
watch(
  [() => form.username, () => form.bb],
  () => {
    const searchParams = {
      username: form.username,
      bb: form.bb,
    };
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(searchParams));
  },
  { deep: false }
);

// 读取缓存回填表单
const loadSearchCache = () => {
  const cacheStr = sessionStorage.getItem(STORAGE_KEY);
  if (cacheStr) {
    try {
      const cache = JSON.parse(cacheStr);
      form.bb = cache.bb ?? "";
      form.username = cache.username ?? "";
    } catch (e) {
      sessionStorage.removeItem(STORAGE_KEY);
    }
  }
};

const save = async () => {
  const sendata = {
    id: upid.value, //用户id
    version: upbb.value, //版本
  };
  console.log(sendata, "传的参数对不对");
  const res = await proxy.$api.System.MemberVersion.update(sendata);
  if (res.data.code == 200) {
    dialogTableVisible.value = false;
    proxy.$message.success("修改成功");
    getList();
  } else {
    proxy.$message.error("网络错误");
  }
};

const saves = async () => {
  getList();
};

const up = (row) => {
  console.log(row, "拿到的是不是当行数据");
  upbb.value = row.version;
  upid.value = row.id;
  dialogTableVisible.value = true;
};

const getList = async () => {
  const sendata = {
    nickName: form.username, //用户名
    version: form.bb, //版本
  };
  const res = await proxy.$api.System.MemberVersion.get(sendata);
  console.log(res.data.code);
  if (res.data.code == 200) {
    users.value = res.data.data.list;
    console.log(users.value, "返回的列表是什么格式");
  } else {
    proxy.$message.error("网络错误");
    users.value = [];
  }
};

const delUser = (id) => {
  // const sendata = { id: id };
  // const res = await proxy.$api.System.MemberVersion.del(sendata);
  // if (res.data.code == 200) {
  //   form.username = "";
  //   form.gw = "";
  //   proxy.$message.success("删除成功");
  //   getList();
  // } else {
  //   proxy.$message.error("网络错误");
  //   form.username = "";
  //   form.gw = "";
  // }
  console.log(id);
  proxy.$message.error("接口待完善");
};

onMounted(() => {
  loadSearchCache();
  getList();
});
</script>

<style lang="scss" scoped>
@import "./member-version.scss";
.panel-title {
  color: #999;
}
.publish-btn {
  background-color: #ff9900;
}
</style>
